import React from "react";

import { withFilterSectionSwatch } from "./withFilterSectionSwatch";

import { ColourSwatch } from "@bared/ui";

export const FilterSectionSwatch = withFilterSectionSwatch(
  ({ options, handleChange, showMore, handleShowMore }) => {
    return (
      <ColourSwatch
        options={options}
        maxOptionsToShow={10}
        handleChange={handleChange}
        showMore={showMore}
        handleShowMore={handleShowMore}
      />
    );
  },
);
